import { render, staticRenderFns } from "./KPI.vue?vue&type=template&id=acabb4d2&scoped=true"
import script from "./KPI.vue?vue&type=script&lang=ts"
export * from "./KPI.vue?vue&type=script&lang=ts"
import style0 from "./KPI.vue?vue&type=style&index=0&id=acabb4d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acabb4d2",
  null
  
)

export default component.exports